import { AppEnvironment } from './environment.model';

let base_url_cadre = "https://stage-cadweb.lokos.in";

export const environment: AppEnvironment = {
    cadreBaseUri: base_url_cadre + '/api',
    cdnUrl: 'https://cdn.lokos.in/lokos-masterdata/',
    baseUrl: 'https://cdn.lokos.in/lokos/uat',
    profileUrl: base_url_cadre + '/api/cadre-profile/v1/cadre-profile/',
    // keycloak: {
    //     issuer: 'https://accounts.lokos.in/',
    //     realm: 'lokos',
    //     clientId: 'cadre-web'
    // },
    keycloak: { issuer: 'https://identity.lokos.in/', realm: 'lokos', clientId: 'web-console' },
    keycloakImageUrl:'https://admin.lokos.in/api/keycloak/v1/realms/lokos/image',
    masterCdnBaseUri: 'https://cdn.lokos.in/lokos-masterdata/',

    reportingBaseUri: 'https://stageprod.lokos.in/api/reports/v3/reporting/',
    reportingSubscriptionKey: '5598bad5185c48efb912531c1fd18dcd',
    reportingKcv: 'secure-identity',
    production: true,
    storageSecretKey: "962771dd-7233-48fc-ad80-1a83af19d737",
    subscriptionKey: "af33e1a7aeaf40b68326f85d7ba85a1f",
    masterCadreBaseUri: base_url_cadre + '/api/cadre-master/v1/',
    geoMapCdnUrl: 'https://cdn.lokos.in/keycloak/geo-map.json',
    masterCdnUri: 'https://cdn.lokos.in/',
    userinfo: "https://identity.lokos.in/realms/lokos/protocol/openid-connect/userinfo",
    fcmNotifyURI: base_url_cadre + '/api/cadre-notification/v1/cadre-notify/send',
    shgUrl: 'https://apis.lokos.in/search/lab/cbo',
    enableEncryption: false,
    fdmBaseUrl: base_url_cadre + '/',
    cboUrl: 'https://apis.lokos.in/search/lab/cbo',
    federationSearchUrl: 'https://prod.lokos.in/group/v2/federation/search_federation/',
    permission: 'https://api.lokos.in/api/keycloak/v1/realms/lokos/permission/',
    downloadUrl: 'https://stage-fdm.lokos.in/api/vault/cadre/v1/',
    userInfoSubscriptionKey:  "c520712fcd0d4c9ca19955c3052eedd6",
    permissionSubscriptionKey: "7511f1a237fa45898f255dd4a52b2282",
    token: "&sp=r&st=2026-02-20T11:51:01Z&se=2026-03-05T20:06:01Z&spr=https&sv=2024-11-04&sr=c&sig=kD4fVuF04Cv1%2BLXkSCydtykH4a7lML5xxmbq%2FYVtbDE%3D"

};
